import { FooterProps } from '../Footer/footer.props'
import {
  TextField,
  BooleanField,
  ImageField,
  EnumField,
} from '@sentecacommerce-theme/base'
import { SuggestedMenu } from '../Navbar/navbar.props'
import { TopStripType } from '../Navbar/Components/TopNavStrip/index'

export enum BottomMenuEnum {
  empty = 'No content',
  moreProducts = 'Additional products',
  promo = 'Promotional products',
}

export type SearchBoxLabels = {
  recentSearchesLabel: TextField
  popularSearchesLabel: TextField
  suggestedBrandsLabel: TextField
  suggestedCategoriesLabel: TextField
  productsLabel: TextField
  promoOffersLabel: TextField
  blogLabel: TextField
  blog: {
    blogTitle: TextField
    image: ImageField
    description: TextField
    url: TextField
  }
}

export type SearchBox = {
  labels: SearchBoxLabels
  labelsColor: TextField
  textColor: TextField
  priceColor: TextField
  backgroundColor: TextField
  bottomMenu: EnumField<BottomMenuEnum>
  withRecent: BooleanField
  withSuggested: BooleanField
}

export type MenuSubcategory = {
  menuName: TextField
  menuUrl: TextField
  menuDescription?: TextField
  menuClass?: TextField
}

export type MenuColumns = {
  col1: MenuSubcategory[]
  col2?: MenuSubcategory[]
}

export type BaseMenuItem = {
  menuName: TextField
  menuDescription?: TextField
  menuUrl: BooleanField | TextField
  menuImage?: BooleanField | TextField
  menuImageLabel?: BooleanField | TextField
  menuImageLink?: BooleanField | TextField
  menuLabel?: BooleanField | TextField
  menuClass?: TextField
  nodes?: BaseMenuItem[]
  columns?: MenuColumns
  disabled?: BooleanField
}

export type MenuItem = MenuColumns | BaseMenuItem

export type Labels = {
  productsLabel: TextField
  noResultsFound: TextField
  brandsLabel: TextField
  categoriesLabel: TextField
  seeAllLabel: TextField
  search: TextField
  me: TextField
  free: TextField
  overPrice: TextField
  ariaLabelsAltsPlaceholders: {
    search: TextField
    location: TextField
    favorites: TextField
    basket: TextField
    logo: TextField
    mainBanner: TextField
  }
  categories: TextField
  brandsAZ: TextField
  myAccount: TextField
  favorites: TextField
  basket: TextField
  info: TextField
  stores: TextField
  phoneNumber: TextField
}

export type MenuLayoutProps = {
  menuItems: BaseMenuItem[]
  footer: FooterProps
  background?: 'secondary' | 'lightgrey' | string
  suggestedMenus: SuggestedMenu[]
  topStrip: TopStripType[]
  searchBox: SearchBox
  labels: Labels
}
